import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [darkmode, setDarkmode] = useState(true);
  const [darkModeLoading, setDarkModeLoading] = useState(true);

  useEffect(() => {
    try {
      if (darkmode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    } catch (e) {
      console.log(e);
    }
  }, [darkmode]);

  return (
    <ThemeContext.Provider
      value={{
        darkmode,
        setDarkmode,
        darkModeLoading,
        setDarkModeLoading,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
};

export default ThemeContext;
